export default "__VITE_ASSET__Cw$oHi0H__"